<script lang="ts" module>
    export const TYPE = Symbol("debug-widget-type");
    export type Props =
        | { [TYPE]: "button"; title: string; onClick: () => void }
        | { [TYPE]: "json"; content: Content; onChange: OnChange }
        | { [TYPE]: "switch"; label: string; value: boolean; onChange: (x: boolean) => void }
        | { [TYPE]: "link"; value: string; label: string }
        | {
              [TYPE]: "select";
              value: string;
              options: { value: string; label: string }[];
              onChange: (x: string) => void;
          };
</script>

<script lang="ts">
    import { Button } from "../ui/button/index.js";
    import { Switch } from "../ui/switch/index.js";
    import { JSONEditor, type OnChange, type Content } from "svelte-jsoneditor";
    import Unreachable from "./unreachable.svelte";
    import { Label } from "../ui/label/index.js";
    import * as NativeSelect from "../ui/native-select/index.js";
    const props: Props = $props();
    let jsonEditor = $state<JSONEditor>();

    $effect(() => {
        if (jsonEditor) {
            setTimeout(() => {
                jsonEditor?.collapse([], true);
            }, 0);
        }
    });
</script>

{#if props[TYPE] === "button"}
    <div class="p-1">
        <Button onclick={props.onClick}>{props.title}</Button>
    </div>
{:else if props[TYPE] === "switch"}
    <div class="flex items-center space-x-2">
        <Label>
            <Switch checked={props.value} onCheckedChange={props.onChange} />
            {props.label}
        </Label>
    </div>
{:else if props[TYPE] === "link"}
    <div class="p-1">
        <a href={props.value} target="_blank">{props.label}</a>
    </div>
{:else if props[TYPE] === "json"}
    {#if "json" in props.content && props.content.json === undefined}
        No JSON provided
    {:else}
        <JSONEditor bind:this={jsonEditor} content={props.content} onChange={props.onChange} />
    {/if}
{:else if props[TYPE] === "select"}
    <NativeSelect.Root bind:value={() => props.value, x => props.onChange(x)}>
        {#each props.options as x (x.value)}
            <NativeSelect.Option value={x.value}>{x.label}</NativeSelect.Option>
        {/each}
    </NativeSelect.Root>
{:else}
    <Unreachable value={props} />
{/if}
